import { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getLogs } from '../../../redux/features/feeForecastSlice';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { Box, MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FORECAST_TBL_HEAD } from '../../../components/datagrid/myworkspace/finance/forecast/ForecastTblHead';
import { getProjects } from '../../../redux/features/refundSlice';

const FeeForecastLatest = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(dayjs());
  const { logs, loading } = useSelector((state) => state.feeForecast);
  const { meta, data } = logs;
  const { projectslist } = useSelector((state) => state.refund);
  const [projectId, setProjectId] = useState('');

  const handleChange = (event) => {
    setProjectId(event.target.value);
  };

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    checkedRowIds: [],
    hiddenColumns: [],
  });

  const dispatchParams = useMemo(() => {
    return {
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      month: dayjs(value).format('MM'),
      year: dayjs(value).format('YYYY'),
      sortKey: tableState.sort.field,
      sortDir: tableState.sort.direction,
      project: projectId,
    };
  }, [
    tableState?.page,
    tableState?.pageSize,
    tableState?.search,
    value,
    tableState.sort.field,
    tableState.sort.direction,
    projectId,
  ]);
  useEffect(() => {
    dispatch(getLogs(dispatchParams));
  }, [dispatchParams]);
  useEffect(() => {
    dispatch(getProjects());
  }, []);

  return (
    <GlobalWrapper
      title={'Forecast'}
      actions={
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={['year', 'month']}
              value={value}
              onChange={(newValue) => setValue(newValue)}
              format="MMM YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      }
    >
      <Box sx={{ pb: 2 }}>
        <Box>
          <TextField select label="Project" size="small" value={projectId} onChange={handleChange} fullWidth>
            {projectslist.map((project) => (
              <MenuItem key={project.id} value={project.id}>
                {project.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
      <GlobalTable
        headers={FORECAST_TBL_HEAD}
        loading={loading}
        meta={meta}
        rows={data}
        exportParams={{ page: 1, limit: 'no' }}
        exportApi={getLogs}
        tableState={tableState}
        setTableState={setTableState}
        rowUniqueId="course_enrollment_id"
      />
    </GlobalWrapper>
  );
};

export default FeeForecastLatest;
